// extracted by mini-css-extract-plugin
module.exports = {"offersContainer":"Offers_offersContainer__1KaVL","offer":"Offers_offer__1aPft","imageWrapper":"Offers_imageWrapper__1WrfK"};